import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { BaseAlert } from '@context/global/typescript';
import alertsStore from '@context/global/mobx/alertStore';
import styles from '@components/Alerts/Alerts.styles';
import Heading from '@components/Heading/Heading';
import Button from '@components/Button/Button';
type PropsType = {
  alert: BaseAlert | null;
};
const Alert = ({
  alert
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  if (!alert || !alert.display) {
    return null;
  }
  const alerts = alertsStore;
  const handleRefresh = () => {
    alerts.hideAlert();
    router.reload();
  };
  return <div sx={styles.alertContainer}>
      <div sx={styles.alertContent}>
        <Heading h={4} headingType={4} pb={24} bold align="center">
          {t('alerts.header')}
        </Heading>
        <div sx={styles.message}>{alert.message}</div>
        <Button variant="outlined" variantColor="dark" size="small" onClick={handleRefresh}>
          {t('alerts.button.refresh')}
        </Button>
      </div>
    </div>;
};
export default observer(Alert);